var _ellipse, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9014,
    cy: 28,
    rx: 28,
    ry: 28,
    fill: "#C6CCFE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 56
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9014,
    cy: 28,
    rx: 28,
    ry: 28,
    fill: "#C6CCFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2954 28.2471C17.2954 34.6305 22.5182 39.8533 28.9017 39.8533C35.2851 39.8533 40.5079 34.6305 40.5079 28.2471",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.009 42.7549C23.0981 44.6119 25.7675 45.6564 28.6691 45.6564C31.5707 45.6564 34.2401 44.6119 36.3292 42.7549",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2405 31.8449C32.8478 33.2377 30.9908 34.1662 28.9016 34.1662C26.6964 34.1662 24.6073 33.1216 23.3306 31.6128",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9378 37.5312V39.9686C21.9378 41.8256 20.4289 43.3344 18.5719 43.3344H14.974C11.1439 43.3344 8.01025 46.4681 8.01025 50.2981",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7924 50.2981C49.7924 46.4681 46.6587 43.3344 42.8286 43.3344H39.2307C37.3737 43.3344 35.8649 41.8256 35.8649 39.9686V37.5312",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9023 47.978V50.2993",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0256 49.1401H32.3831",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4197 49.1401H20.7772",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2947 21.2832H14.7414C14.1611 21.2832 13.8129 21.7475 13.8129 22.2117V28.363C13.8129 29.5236 14.7414 30.5682 16.0181 30.5682H17.2947",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5073 21.2832H43.0607C43.641 21.2832 43.9892 21.7475 43.9892 22.2117V28.363C43.9892 29.5236 43.0607 30.5682 41.784 30.5682H40.5073",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2954 23.6047V15.4803C17.2954 10.3736 21.4737 6.19531 26.5804 6.19531H31.2229C36.3297 6.19531 40.5079 10.3736 40.5079 15.4803V23.6047",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.508 22.4433H26.5805C24.0271 22.4433 21.938 20.3542 21.938 17.8008",
    stroke: "#1C2F4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/default-photo.5ae6e56dd406e7f96c9fb23aea5c3477.svg";
export { ForwardRef as ReactComponent };